import React, {useState, useEffect} from 'react';
import {Link} from 'react-router-dom';
import { urlRoot } from '../utils/data';
import { useStateContext } from '../context/stateContext';

const Header = () => {
    const {lightTheme, setLightTheme, setLinkHovred, isNotProject, prevLink, nextLink} = useStateContext();
    const [showMenu, setShowMenu] = useState(false);

    useEffect(()=>{
        let hours= new Date().getHours();
        if(hours >= 18 || hours <= 7){
            setLightTheme(false);
        }
    },[])

    return (
        <header className={`header ${lightTheme?"light":"dark"}`}>
            <div className="container">
                <Link to="/" onMouseLeave={()=>setLinkHovred(false)} onMouseEnter={()=>setLinkHovred(true)}>
                    <img src={`${urlRoot}assets/logo.png`} alt="logo" className="logo" />
                </Link>
                <div className={`burger-icon ${showMenu?"active":null}`} onClick={()=>setShowMenu(!showMenu)} onMouseLeave={()=>setLinkHovred(false)} onMouseEnter={()=>setLinkHovred(true)}>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
                <nav>
                    <div className="mode-icon" onClick={()=>setLightTheme(!lightTheme)} onMouseLeave={()=>setLinkHovred(false)} onMouseEnter={()=>setLinkHovred(true)}>
                        {/* <i className={`fa-solid ${lightTheme?"fa-moon":"fa-sun"}`}></i> */}
                        {lightTheme?(
                        <>
                            <link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@48,400,0,0" />
                            <span class="material-symbols-outlined">
                            sleep
                            </span>
                        </>
                        ):(
                        <>
                            <link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@48,400,0,0" />
                            <span class="material-symbols-outlined">
                            light_mode
                            </span>
                        </>
                        )}

                    </div>
                    <ul className={`${lightTheme?"light":"dark"} ${showMenu?"active":null}`}>
                        {isNotProject ?(
                            <>
                            <li><a onClick={()=>setShowMenu(false)} onMouseLeave={()=>setLinkHovred(false)} onMouseEnter={()=>setLinkHovred(true)} href="/#home">Home</a></li>
                            <li><a onClick={()=>setShowMenu(false)} onMouseLeave={()=>setLinkHovred(false)} onMouseEnter={()=>setLinkHovred(true)} href="/#about">About</a></li>
                            <li><a onClick={()=>setShowMenu(false)} onMouseLeave={()=>setLinkHovred(false)} onMouseEnter={()=>setLinkHovred(true)} href="/#skills">Skills</a></li>
                            <li><a onClick={()=>setShowMenu(false)} onMouseLeave={()=>setLinkHovred(false)} onMouseEnter={()=>setLinkHovred(true)} href="/#projects">Projects</a></li>
                            <li><a onClick={()=>setShowMenu(false)} onMouseLeave={()=>setLinkHovred(false)} onMouseEnter={()=>setLinkHovred(true)} href="/#contact">Contact</a></li>
                            </>
                        ):(
                            <>
                                <li>
                                    <Link 
                                        className='btn-link'
                                        to={prevLink}
                                        onMouseLeave={()=>setLinkHovred(false)}
                                        onMouseEnter={()=>setLinkHovred(true)}
                                    >
                                        Prev Project
                                    </Link>
                                </li>
                                <li>
                                    <Link
                                        className='btn-link'
                                        to={nextLink}
                                        onMouseLeave={()=>setLinkHovred(false)}
                                        onMouseEnter={()=>setLinkHovred(true)}
                                    >
                                        Next Project
                                    </Link>
                                </li>
                            </>
                        )}
                    </ul>
                </nav>
            </div>
        </header>
    )
}

export default Header
